import PropTypes from "prop-types";
import React from "react";
import Modal from "../modal";

class VideoModal extends React.Component {
  render() {
    const { locals } = this.context;
    const { query, origin } = locals;

    return (
      <Modal width="1000px">
        <div className="head">Welcome Video</div>
        <iframe
          className="Welcome-Video"
          src={`https://www.youtube.com/embed/ib9Axcatw1Y?rel=0&amp;showinfo=0&amp;autoplay=false`}
          allowFullScreen
        ></iframe>
      </Modal>
    );
  }
}

VideoModal.contextTypes = { locals: PropTypes.object };

export default VideoModal;
